export const getChecklistVisibilityStorageKey = (userId?: string) =>
  `CONTRA_SESSION_PROFILE_CHECKLIST_DISMISSED_USER_ACCOUNT_${(
    userId ?? 'NA'
  ).toUpperCase()}` as const;

export const getChecklistExpansionStorageKey = (userId?: string) =>
  `CONTRA_SESSION_PROFILE_CHECKLIST_WAS_COLLAPSED_USER_ACCOUNT_${(
    userId ?? 'NA'
  ).toUpperCase()}` as const;

export type ChecklistVariant = 'apply' | 'discover' | 'launch';
